import { BaseEntityInput } from '@/modules/entity-management/types';
import {
    sampleContactPhoneNumber,
    sampleEntityNames,
    sampleStrings,
    specialTypeSamplePool,
} from '@/modules/entity-management/utils/csv-sample/constants';

function containsCollateralsData(value: any): boolean {
    const containsCollateralData = (val: any) => val != null && typeof val === 'object' && (
        // limitRequired and maxDeductible are number(all value has chance to be used), don't consider as sample
        specialTypeSamplePool.collaterals.description.includes(val.description) ||
        specialTypeSamplePool.collaterals.category.includes(val.category) ||
        specialTypeSamplePool.collaterals.uniqueIdentifier.includes(val.uniqueIdentifier)
    );
    return Array.isArray(value) && value.some(containsCollateralData);
}

function containsEquipmentData(value: any): boolean {
    // Guards `val`, not the enclosing array: a hand-edited CSV can leave a bare `null` segment in
    // a pipe-separated cell, and reading a property off it would abort the whole file's import.
    const containsEquipmentDataInValue = (val: any) => val != null && typeof val === 'object' && (
        // equipmentValue, rentalCompleteDate and rentalProtectionPlan are values any real rental
        // could plausibly have, so they aren't considered as sample
        specialTypeSamplePool.equipment.description.includes(val.description) ||
        specialTypeSamplePool.equipment.rentalId.includes(val.rentalId)
    );
    return Array.isArray(value) && value.some(containsEquipmentDataInValue);
}

function hasSpecialTypeSampleData(value: any): boolean {
    return containsCollateralsData(value) || containsEquipmentData(value);
}

export function isSampleEntity(insured: BaseEntityInput): boolean {
    const containsSampleEntityNames: boolean = sampleEntityNames.some((sampleInsured) =>
        sampleInsured.displayName === insured.displayName?.trim() ||
        insured.contactEmail?.includes(`${sampleInsured.domain}`));
    const containsSamplePhoneNumber: boolean = sampleContactPhoneNumber.some((number) =>
        `+1${number.replace(/\D/g, '')}` === insured.contactPhoneNumber);
    const containsSampleDomainInInsuredFields: boolean = sampleEntityNames.some((sampleInsured) =>
        (insured.insuredFields
            ? Object.values(insured.insuredFields).some((value) =>
                typeof value === 'string' && value.includes(sampleInsured.domain))
            : false));
    const containsSampleStringInInsuredFields: boolean = sampleStrings.some((sampleString) =>
        (insured.insuredFields
            ? Object.values(insured.insuredFields).some((value) =>
                typeof value === 'string' && value.includes(sampleString))
            : false));
    const containsSpecialTypeInsuredFields: boolean = insured.insuredFields
        ? Object.values(insured.insuredFields).some(hasSpecialTypeSampleData)
        : false;
    return containsSampleEntityNames || containsSamplePhoneNumber || containsSampleDomainInInsuredFields
        || containsSampleStringInInsuredFields || containsSpecialTypeInsuredFields;
}
